import React, { useEffect, useRef, useState } from "react";
import { ThemeProvider } from "styled-components";
import defaultTheme from "../../themes/defaultTheme";
import peaksTheme from "../../themes/peaksTheme";
import { getLogger } from "../../utils/DebugUtils";
import { getTheme } from "./AlmeTenants";
export const ThemeWrapper = (props) => {
    const [theme, setTheme] = useState(defaultTheme);
    const themeLoadInitiated = useRef(false);
    useEffect(() => {
        if (!themeLoadInitiated.current) {
            themeLoadInitiated.current = true;
            // Default theme for VISTA is `defaultTheme`, so checking for only other platforms
            if (props.platform === "PEAKS") {
                setTheme(peaksTheme);
            }
            else if (props.platform !== "VISTA") {
                getTheme(props.tenant.theme)
                    .then(t => setTheme(t))
                    .catch(e => {
                    getLogger(props.uiLogLevel).error("Unable to download themes", e);
                });
            }
        }
    }, [props.platform, props.tenant, props.uiLogLevel]);
    return (React.createElement(ThemeProvider, { theme: theme }, props.children));
};
